import { color, textSize, backgroundColor, zIndex } from 'styles/helpers'
import config from 'styles/config'
import logoutSvg from 'styles/images/power-off.svg'

const headerStyles = {
  header: {
    overflow: 'hidden',
    padding: '10px 10px 0 10px',
    position: 'relative',
    zIndex: 'auto',
  },
  withShadow: {
    ...backgroundColor('mainBackground'),
    boxShadow: config.colors.headerShadow,
  },
  wrap: {
    position: 'relative',
    ...zIndex('header'),
    maxWidth: 1200,
    margin: '0 auto',
    padding: '30px 0 0 0'
  },
  logo: {
    display: 'block',
    margin: '0 auto 16px auto',
    width: '55%',
    height: 90,
    backgroundSize: 'contain',
    backgroundPosition: 'center'
  },
  user: {
    position: 'absolute',
    left: 0,
    top: 0,
    padding: '0 0 0 16px',
    backgroundColor: 'transparent',
    ...color('textSecondary'),
    ...textSize(13, 18),
    '&:before': {
      content: '" "',
      position: 'absolute',
      left: 0,
      top: 3,
      width: 12,
      height: 12,
      backgroundImage: `url(${logoutSvg})`
    }
  },
  [config.mediaQueries.tabletPortrait]: {
    header: {
      ...zIndex('header'),
    },
    logo: {
      marginBottom: 24,
    }
  }
}

export default headerStyles
